import axios from 'axios'

import { useLanguageStore } from '../store/languageStore'

const instance = axios.create({
  headers: {
    'Content-type': 'application/json',
  },
})

instance.interceptors.request.use(function (config: any) {
  // const url = "https://visma-back.unacorbatanegra.dev"; DIGITAL OCEAN
  // const url = "https://back-dev.azurewebsites.net/"; AZURE
  //const url = 'http://localhost:8080'

  const url = 'https://api.payroll.bdoargentina.com'
  config.baseURL = url
  config.headers['X-Language'] = useLanguageStore.getState().language
  return config
})

instance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      // Check for password expiration error
      // Adjust the condition based on actual backend response
      if (
        error.response.status === 403 &&
        (error.response.data?.message === 'Password expired' ||
          error.response.data?.code === 'password_expired')
      ) {
        window.location.href = '/password-expired'
      }
    }
    return Promise.reject(error)
  },
)

export default instance
